import ApiService, { errorMessage } from "helpers/ApiHelper";

const ROOT = "/api/v1/posts";

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    // An empty search box or a cleared filter must drop out of the URL
    // entirely — sending `status=` would fail validation rather than mean
    // "any status".
    if (value !== undefined && value !== null && value !== "") search.append(key, value);
  });
  const qs = search.toString();
  return qs ? `?${qs}` : "";
};


/** Admin listing: one language, paginated, with optional status/category/search filters. */
export const fetchPosts = (params) => ApiService.request(`${ROOT}${query(params)}`, "get");

/** One post with its body, plus the other languages in its translation group. */
export const fetchPost = (id) => ApiService.request(`${ROOT}/${id}`, "get");

export const createPost = (body) => ApiService.request(ROOT, "post", body);

export const updatePost = (id, body) => ApiService.request(`${ROOT}/${id}`, "patch", body);

/** Publishing is its own call — a save must never change what the site serves. */
export const setPostStatus = (id, status) =>
  ApiService.request(`${ROOT}/${id}/status`, "patch", { status });

export const deletePost = (id) => ApiService.request(`${ROOT}/${id}`, "delete");

export const fetchCategories = (lang) =>
  ApiService.request(`${ROOT}/categories/all${query({ lang })}`, "get");

export const createCategory = (body) => ApiService.request(`${ROOT}/categories`, "post", body);

export const updateCategory = (id, body) =>
  ApiService.request(`${ROOT}/categories/${id}`, "patch", body);

export const deleteCategory = (id) => ApiService.request(`${ROOT}/categories/${id}`, "delete");

// Re-exported so the screens keep importing it from their own api module.
export { errorMessage };
